import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class HubApi extends Requestor {
    getHubsMe(params = {}) {
        return this.get({
            url: '/api/v1/hubs/me',
            params,
        });
    }
    getHubList(params = {}) {
        return this.get({
            url: '/api/v1/hubs',
            params,
        });
    }
    getHub(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}`,
            params,
        });
    }
    putHubConfiguration(hubId = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/configuration`,
            data,
        });
    }
    // 라이더 관리 자동 차감 그룹 (C,R,U,D)
    postWorkerCashAutoDeductGroup(hubId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group`,
            data,
        });
    }
    getWorkerCashAutoDeductGroup(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group`,
            params,
        });
    }
    putWorkerCashAutoDeductGroup(hubId = '', id = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group/${id}`,
            data,
        });
    }
    deleteWorkerCashAutoDeductGroup(hubId = '', id = '') {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group/${id}`,
        });
    }
    // 라이더 관리 자동 차감 그룹 라이더 등록
    postWorkerCashAutoDeductGroupRegister(hubId = '', groupId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group/${groupId}/workers`,
            data,
        });
    }
    // 라이더 관리 자동 차감 그룹 스케줄 설정 (C,R,U,D)
    postWorkerCashAutoDeductGroupOption(hubId = '', groupId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group/${groupId}/option`,
            data,
        });
    }
    getWorkerCashAutoDeductGroupOption(hubId = '', groupId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-options/${groupId}`,
            params,
        });
    }
    putWorkerCashAutoDeductGroupOption(hubId = '', groupId = '', id = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group/${groupId}/options/${id}`,
            data,
        });
    }
    deleteWorkerCashAutoDeductGroupOption(hubId = '', groupId = '', id = '') {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-cash-auto-deduct-group/${groupId}/options/${id}`,
        });
    }
    // 라이더 관리 배달대행료 수수료 그룹 (C,R,U,D)
    postWorkerDeliveryFeeGroup(hubId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group`,
            data,
        });
    }
    getWorkerDeliveryFeeGroup(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group`,
            params,
        });
    }
    putWorkerDeliveryFeeGroup(hubId = '', id = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${id}`,
            data,
        });
    }
    deleteWorkerDeliveryFeeGroup(hubId = '', id = '') {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${id}`,
        });
    }
    // 라이더 관리 배달대행료 수수료 그룹 라이더 등록
    postWorkerDeliveryFeeGroupRegister(hubId = '', groupId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${groupId}/workers`,
            data,
        });
    }
    // 라이더 관리 배달대행료 수수료 설정 (C,R,U,D)
    postWorkerDeliveryFeeGroupOption(hubId = '', groupId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${groupId}/options`,
            data,
        });
    }
    getWorkerDeliveryFeeGroupOption(hubId = '', groupId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${groupId}/options`,
            params,
        });
    }
    putWorkerDeliveryFeeGroupOption(hubId = '', groupId = '', id = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${groupId}/options/${id}`,
            data,
        });
    }
    deleteWorkerDeliveryFeeGroupOption(hubId = '', groupId = '', id = '') {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-delivery-fee-group/${groupId}/options/${id}`,
        });
    }
    // 상점별 라이더 배달 대행료 수수료 그룹 (C,R,U,D)
    postWorkerFeePerStoreGroup(hubId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups`,
            data,
        });
    }
    getWorkerFeePerStoreGroup(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups`,
            params,
        });
    }
    putWorkerFeePerStoreGroup(hubId = '', groupId = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}`,
            data,
        });
    }
    deleteWorkerFeePerStoreGroup(hubId = '', groupId = '') {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}`,
        });
    }
    // 상점별 라이더 배달 대행료 수수료 옵션 (C,R,U,D)
    postWorkerFeePerStoreGroupOption(hubId = '', groupId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}/options`,
            data,
        });
    }
    getWorkerFeePerStoreGroupOption(hubId = '', groupId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}/options`,
            params,
        });
    }
    putWorkerFeePerStoreGroupOption(hubId = '', groupId = '', optionId = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}/options/${optionId}`,
            data,
        });
    }
    deleteWorkerFeePerStoreGroupOption(hubId = '', groupId = '', optionId = '') {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}/options/${optionId}`,
        });
    }
    // 허브 상점 배달대행수수료 그룹 매핑 정보 조회
    getWorkerFeePerStoreGroupStoreList(hubId = '', groupId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}/stores`,
            params,
        });
    }
    // 허브 상점 배달대행수수료 그룹 상점 등록/삭제
    putWorkerFeePerStoreGroupStoreList(hubId = '', groupId = '', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-fee-per-store-groups/${groupId}/stores`,
            data,
        });
    }
    // 배차 취소 패널티 그룹 (C,R,U,D)
    postWorkerAllocatedCancelPenaltyGroup(hubId, data) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups`,
            data,
        });
    }
    getWorkerAllocatedCancelPenaltyGroup(hubId, params) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups`,
            params,
        });
    }
    putWorkerAllocatedCancelPenaltyGroup(hubId, groupId, data) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups/${groupId}`,
            data,
        });
    }
    deleteWorkerAllocatedCancelPenaltyGroup(hubId, groupId) {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups/${groupId}`,
        });
    }
    // 배차 취소 패널티 그룹 상세 (R,U)
    getWorkerAllocatedCancelPenaltyGroupDetail(hubId, groupId, params) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups/${groupId}/details`,
            params,
        });
    }
    putWorkerAllocatedCancelPenaltyGroupDetail(hubId, groupId, detailId, data) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups/${groupId}/details/${detailId}`,
            data,
        });
    }
    // 배차 취소 패널티 그룹 라이더 등록/삭제
    postWorkerAllocatedCancelPenaltyGroupWorkerList(hubId, groupId, data) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/worker-allocated-cancel-penalty-groups/${groupId}/register`,
            data,
        });
    }
    /**
     * 발주 허브 설정 조회
     * https://www.notion.so/barogohq/08194f0fd8654cb6ad32ccd1d5f801a2#ea8bdd6f0d0843fd9ec164db4665c260
     * @param {string} hubId 관제중인 허브 아이디
     * @param {*} params
     * @returns
     */
    getAgencyShareInfo(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/agency-share-info`,
            params,
        });
    }
    /**
   * 운행설정 > 이력모달 리스트조회
   * @param hubId 관제중인 허브 아이디
   * @param params
   * @returns
   */
    getOperationSettingHistories(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/operation-setting/histories`,
            params,
        });
    }
    /**
     * 운행설정 적용
     * https://dev-zoo-client-api.barogo.io/docs/api-guide.html#_3_3_%ED%97%88%EB%B8%8C_%EC%9A%B4%ED%96%89_%EC%84%A4%EC%A0%95
     * @param {Object} data
     * @returns {Object}
     */
    postOperationSetting(data) {
        return this.post({
            url: '/api/v1/hubs/operation-setting',
            data,
        });
    }
    postHub(data = {}) {
        return this.post({
            url: '/api/v1/hubs',
            data,
        });
    }
    /**
     *
     * @param hubId
     * @param type basic | worker-operation | adjustment-operation
     * @param data
     * @returns
     */
    putHubInfo(hubId = '', type = 'basic', data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/${type}`,
            data,
        });
    }
    postHubRepresentativePhoneExistence(data = {}) {
        return this.post({
            url: '/api/v1/hubs/representative-phone/existence',
            data,
        });
    }
}
export default new HubApi(clientInstance);
